export const removeDuplicates = (array) => {
  const newArray = array.filter((value, index, self) =>
    index === self.findIndex((t) => (
      t.value === value.value && t.text === value.text
    ))
  )
  return newArray
}